import React from "react";
import "./AboutHero.css";
import heroImg from "../img/New/abouthero.png";

const AboutHero = () => {
  return (
    <section className="oglitz-about-hero">
      <div className="oglitz-about-hero-container">
        {/* LEFT CONTENT */}
        <div className="oglitz-about-hero-content">
          <span className="oglitz-about-hero-badge">Global IT Company</span>

          <h1 className="oglitz-about-hero-title">
            Building <span>Scalable Digital Solutions</span> for a Global Future
          </h1>

          <p className="oglitz-about-hero-desc">
            Oglitz Software is a technology-driven IT services company
            delivering innovative, secure, and scalable solutions for businesses
            across
            <strong> India and UAE (Dubai)</strong>.
          </p>

          {/* LOCATION LABELS */}
          <div className="oglitz-about-hero-locations">
            <span className="oglitz-about-hero-location">🇮🇳 India</span>
            <span className="oglitz-about-hero-location">🇦🇪 Dubai, UAE</span>
          </div>

          {/* ACTION BUTTONS */}
          <div className="oglitz-about-hero-actions">
            <a href="/start-project" className="oglitz-about-hero-btn-primary">
              Start Your Project
            </a>

            <a href="/contact" className="oglitz-about-hero-btn-secondary">
              Talk to Experts
            </a>
          </div>
        </div>

        {/* RIGHT IMAGE */}
        <div className="oglitz-about-hero-image">
          <img src={heroImg} alt="Oglitz global IT team" loading="lazy" />
        </div>
      </div>
    </section>
  );
};

export default AboutHero;
